import React from "react";

import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row py-4">
          <div className="col-12 col-md-4 mb-4 mb-md-0">
            <h6 className="font-weight-bold mb-3">Date generale</h6>
            <ul className="company">
              <li><a target="_blank" rel="noopener noreferrer" href="/media/politica_de_confidentialitate.pdf">Politica de confidentialitate</a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="/media/gdpr.pdf">GDPR</a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="/media/formular_garantii.pdf">Formular garantii</a></li>
              <li><a target="_blank" rel="noopener noreferrer" href="/media/formular_retur.pdf">Formular retur</a></li>
            </ul>
          </div>
          <div className="col-12 col-md-4 mb-4 mb-md-0">
            <h6 className="font-weight-bold mb-3">Contact</h6>
            <ul className="company">
              <li><a href="mailto:office@asparts.ro">office@asparts.ro</a></li>
              <li><a href="tel:0726733707">0726733707</a></li>
            </ul>
          </div>
          <div className="col-12 col-md-4">
            <h6 className="font-weight-bold mb-3">Companie</h6>
            <ul className="company">
              <li>Automotive Spare Parts S.R.L.</li>
              <li>RO38837182</li>
              <li>J40/1883/2018</li>
              <li>Str. Industriilor 56 Bucuresti Sect 3</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;